// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3w2dt","name":"Header_name__iLgtk","birthday":"Header_birthday__3XAYa","skeleton":"Header_skeleton___W5-d"};